import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import style from './style.module.scss';

const TableUsersSkeleton = () => {
  const { data: profileData } = useUserProfileQuery();
  return [...Array(11)].map(() => (
    <tr key={uuidv4()} className={style.usersBodyRow}>
      <td className={style.nameColumn}>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td className={style.emailColumn}>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td className={style.usernameColumn}>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      {profileData?.userAccess?.manageUsers && (
        <td className={style.actionsColumn}>
          <div className={style.actionsIconContainer}>
            <SkeletonBlock />
          </div>
        </td>
      )}
    </tr>
  ));
};

export default TableUsersSkeleton;
